import React, { useState, useEffect } from "react";
import { Form, Input, InputNumber, Button, Row, Col, notification } from "antd";
import {
  TagOutlined,
  EnvironmentOutlined,
  PhoneOutlined,
} from "@ant-design/icons";
import { updateSpecialtyApi } from "../../../../api/specialty";
import { getAccessToken } from "../../../../api/auth";

import "./EditSpecialtyForm.scss";

export default function EditSpecialtyForm(props) {
  const { specialty, setIsVisibleModal, setReloadSpecialties } = props;
  const [specialtyData, setSpecialtyData] = useState({});

  //trae los datos de tipo de proveedor
  useEffect(() => {
    setSpecialtyData({
      specialty_code: specialty.specialty_code,
      description: specialty.description,
    });
  }, [specialty]);

  //Verifica que no exista errores en los datos que se deben validar
  const isFormValid = (e) => {
    let errorExists = false;
    if (!specialtyData.description) {
      notification["error"]({
        message: "Obligatorio: descripción.",
      });
      errorExists = true;
    } else {
      errorExists = false;
    }
    return errorExists;
  };

  const updateSpecialty = (e) => {
    e.preventDefault();
    const error = isFormValid();
    if (!error) {
      const token = getAccessToken();
      let specialtyUpdate = specialtyData; //es let porque se va actualizando

      updateSpecialtyApi(token, specialtyUpdate, specialty._id).then(
        (result) => {
          if (
            result.message === "ERR_CONNECTION_REFUSED" ||
            result.message === "Failed to fetch" ||
            result.message === undefined
          ) {
            notification["error"]({
              message: "Servidor caido",
            });
            setIsVisibleModal(true);
          } else if (result.code !== 200) {
            notification["error"]({
              message: result.message,
            });
            setIsVisibleModal(true);
          } else {
            notification["success"]({
              message: result.message, //el mensaje que viene del server
            });
            //console.log("respuesta: " + result.message);
            setIsVisibleModal(false);
            setReloadSpecialties(true);
          }
        }
      );
    }
  };

  return (
    <div className="edit-specialty-form">
      <EditForm
        specialtyData={specialtyData}
        setSpecialtyData={setSpecialtyData}
        updateSpecialty={updateSpecialty}
      />
    </div>
  );
}

function EditForm(props) {
  const {
    specialtyData,
    setSpecialtyData,
    updateSpecialty
  } = props;

  return (
    <Form className="form-edit" onSubmit={updateSpecialty}>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
      <Col span={12}>
          <label className="control-label">Código</label>
          <Form.Item>
            <InputNumber
              prefix={<TagOutlined />}
              placeholder="Automático"
              value={specialtyData.specialty_code}
              onChange={(e) =>
                setSpecialtyData({ ...specialtyData, specialty_code: e })
              }
              style={{ width: "100%" }}
              disabled={true}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <label className="control-label">
            <span className="control-required">* </span>Descripción
          </label>
          <Form.Item>
            <Input
            //   placeholder="descripción"
              value={specialtyData.description}
              onChange={(e) =>
                setSpecialtyData({ ...specialtyData, description: e.target.value })
              }
            />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          className="btn-submit"
          onClick={updateSpecialty}
        >
          Actualizar
        </Button>
      </Form.Item>
    </Form>
  );
}
